import React from 'react';
import PropTypes from 'prop-types';
import Content from './content';

class Layout extends React.PureComponent {
    static propTypes = { content: PropTypes.object };

    async componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const { share_token } = this.props.content;

        return <Content content={share_token} />;
    }
}

export default Layout;
